import { useEffect, useState } from "react";

const KEY = "casaviva_favs";

const read = () => {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); }
  catch { return new Set(); }
};

const write = (set) => {
  localStorage.setItem(KEY, JSON.stringify([...set]));
  window.dispatchEvent(new Event("favs-changed"));
};

export const useFavorites = () => {
  const [favs, setFavs] = useState(() => read());

  useEffect(() => {
    const h = () => setFavs(read());
    window.addEventListener("favs-changed", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("favs-changed", h);
      window.removeEventListener("storage", h);
    };
  }, []);

  const toggle = (id) => {
    const next = new Set(favs);
    if (next.has(id)) next.delete(id); else next.add(id);
    write(next);
    setFavs(next);
  };

  return {
    favs,
    isFav: (id) => favs.has(id),
    toggle,
    list: [...favs],
    count: favs.size,
  };
};
